import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import styles from './styles.scss';
import classnames from 'classnames';

import { ALL_ORGANIZATIONS } from '../../../types/all-organizations';
import { Icons } from '@densityco/ui';
import Tooltip from '../../Tooltip';

export const NAVBAR_SIDEBAR_ITEMS = [
  {
    name: 'In Configuration',
    description: 'Exposes individual unit metadata and algorithm configuration',
    href: organizationIdOrAll => `#/${organizationIdOrAll}/in-configuration`,
    icon: Icons.Cog,
    isActive: location =>
      location.pathname.includes('/sensors') ||
      location.pathname.includes('/in-configuration'),
  },
  {
    name: 'Implemented Spaces',
    description: 'Manage spaces that are currently counting people',
    href: organizationIdOrAll => `#/${organizationIdOrAll}/implemented`,
    icon: Icons.Space,
    isActive: location =>
      location.pathname.includes('/spaces') ||
      location.pathname.includes('/implemented'),
  },
  {
    name: 'Multi Point Installations',
    description:
      'Allows multiple units to work in tandem to cover larger doorways',
    href: organizationIdOrAll => `#/${organizationIdOrAll}/multi-point-installations`,
    icon: Icons.Integrations1,
    isActive: location =>
      location.pathname.includes('/multi-point-installations'),
  },
];

const NavbarSidebar: React.FunctionComponent<{}> = () => {
  const location = useLocation();
  const { organizationIdOrAll } = useParams();

  // Don't show the sidebar for these paths.
  if (['/', '/search'].includes(location.pathname)) {
    return null;
  }

  return (
    <nav className={styles.sidebar}>
      {NAVBAR_SIDEBAR_ITEMS.map(item => (
        <Tooltip
          key={item.name}
          placement="right"
          contents={item.name}
          target={<a
            key={item.name}
            href={item.href(organizationIdOrAll)}
            className={classnames(styles.sidebarLink, {
              [styles.active]: item.isActive(location),
            })}
          >
            <item.icon color="currentColor" />
          </a>}
        />
      ))}
    </nav>
  );
};

export default NavbarSidebar;
